import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { TnbUser } from '../../../service/auth/tnb-user';
import { AuthenticationService } from '../../../service/auth/authentication.service';
import { RoutingService } from '../../../service/common/routing/routing.service';
import { ConfirmDialogService } from '../../../service/common/dialog/confirm-dialog.service';
import { Observable } from 'rxjs';
import { ErzeugungsanlageExportService } from '../../../service/erzeugungsanlage/erzeugungsanlage-export.service';
import { DialogService } from '../../../service/common/dialog/dialog.service';
import { ImportWizardComponent } from '../../../ea-import-wizard/import-wizard/import-wizard.component';
import { NetzbetreiberTeilgebieteInfo } from '../../../service/auth/netzbetreiber-teilgebiete-info';
import { TeilgebietSelectionService } from '../../../service/common/teilgebiet/teilgebiet-selection.service';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'redispatch-navigation-header',
    templateUrl: './navigation-header.component.html',
    styleUrls: [
        './navigation-header.component.scss',
    ],
    standalone: false,
})
export class NavigationHeaderComponent implements OnInit {

    public user$: Observable<TnbUser> = null;
    public selectedTeilgebiet: NetzbetreiberTeilgebieteInfo | undefined;

    public authenticationService = inject(AuthenticationService);
    public routingService = inject(RoutingService);

    private erzeugungsanlageExportService = inject(ErzeugungsanlageExportService);
    private dialogService = inject(DialogService);
    private confirmDialogService = inject(ConfirmDialogService);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    async ngOnInit() {
        this.user$ = this.authenticationService.user$.pipe(
            tap((_) => {
                this.selectedTeilgebiet = this.teilgebietSelectionService.getSelectedTeilgebiet();
            }),
        );
    }

    public login() {
        this.authenticationService.login();
    }

    public async logout() {
        if (await this.confirmDialogService.confirm(
            'Möchten Sie sich wirklich ausloggen?', 'Ausloggen?',
            'primary', 'Ja', 'Nein')) {
            this.teilgebietSelectionService.resetSelection();
            await this.authenticationService.logout();
        }
    }

    public async selectTeilgebiet(teilgebiet: NetzbetreiberTeilgebieteInfo) {
        if (await this.confirmDialogService.confirm(
            `Möchten Sie wirklich das Teilgebiet '${teilgebiet.teilgebiet}' auswählen?`,
            'Teilgebietsauswahl',
            'primary',
            'Ja',
            'Nein')
        ) {
            this.teilgebietSelectionService.setSelectedTeilgebiet(teilgebiet);
            this.selectedTeilgebiet = teilgebiet;
            this.changeDetectorRef.markForCheck();
            window.location.reload();
        }
    }

    public isTeilgebietSelected(teilgebiet: NetzbetreiberTeilgebieteInfo): boolean {
        return this.isSameTeilgebiet(teilgebiet, this.selectedTeilgebiet);
    }

    public isSameTeilgebiet(tgb1: NetzbetreiberTeilgebieteInfo | null, tgb2: NetzbetreiberTeilgebieteInfo | null): boolean {
        return tgb1?.stadtwerkeId === tgb2?.stadtwerkeId;
    }

    public openImportWizard() {
        this.dialogService.openDialog(ImportWizardComponent);
    }

    public export() {
        const teilgebiet = this.teilgebietSelectionService.getSelectedTeilgebiet();
        this.erzeugungsanlageExportService.exportErzeugungsanlagen(
            teilgebiet.stadtwerkeId,
            teilgebiet.teilgebiet,
            false,
        );
    }
}
